import * as React from 'react';
import { ArticleHeading2, ArticleHeading4 } from '@cian/ui-kit';
import * as style from './ReviewsTitle.css';

export interface IReviewsTitleProps {
  reviewCount: number;
  rating: React.ReactElement;
  title: string;
}

export const ReviewsTitle: React.FC<IReviewsTitleProps> = ({ rating, title }) => {
  return (
    <div>
      <div className={style['title']}>
        <ArticleHeading2 as="h2">{title}</ArticleHeading2>
      </div>
      <div className={style['rating']}>{rating}</div>
      <ArticleHeading4>Самые популярные отзывы</ArticleHeading4>
    </div>
  );
};
